export default function friendlyBaseError(e) {
  const raw =
    e?.shortMessage ||
    e?.message ||
    e?.cause?.shortMessage ||
    e?.cause?.message ||
    e?.error?.message ||
    e?.data?.message ||
    e?.response?.data?.details ||
    e?.response?.data?.message ||
    "";

  const lower = String(raw).toLowerCase();
  const code = e?.code ?? e?.cause?.code ?? e?.data?.code;

  // User rejected (MetaMask/Coinbase typically 4001)
  if (code === 4001 || lower.includes("user rejected") || lower.includes("rejected the request")) {
    return {
      kind: "REJECTED",
      msg: "You cancelled the request in your wallet. No transaction was sent.",
      raw,
    };
  }

  // Network / chain mismatch
  if (
    lower.includes("does not match the target chain") ||
    lower.includes("chain mismatch") ||
    lower.includes("wrong network") ||
    lower.includes("incorrect network") ||
    lower.includes("expected chain") ||
    lower.includes("target chain")
  ) {
    return {
      kind: "NETWORK",
      msg: "Wrong network — switch your wallet to Base and try again. No transaction was sent.",
      raw,
    };
  }

  // Chain not added
  if (code === 4902 || lower.includes("unrecognized chain") || lower.includes("unknown chain")) {
    return {
      kind: "ADD_CHAIN",
      msg: "Base isn’t available in your wallet yet. Please add the Base network and try again. No transaction was sent.",
      raw,
    };
  }

  // Coinbase Wallet preview / simulation issues
  if (
    lower.includes("no está disponible la vista previa") || // ES Coinbase
    lower.includes("vista previa de la transacción") ||
    lower.includes("preview is not available") ||
    lower.includes("cannot preview") ||
    lower.includes("failed to simulate") ||
    lower.includes("simulation failed")
  ) {
    return {
      kind: "SIMULATION",
      msg: "Your wallet couldn’t preview this transaction (usually not enough ETH for gas, or the payment would be rejected). No transaction was sent.",
      raw,
    };
  }

  // Funds / gas
  if (
    lower.includes("insufficient funds") ||
    lower.includes("not enough funds") ||
    lower.includes("gas") && lower.includes("insufficient")
  ) {
    return {
      kind: "FUNDS",
      msg: "Not enough funds to cover network fees (gas) on Base. You need a little ETH on Base. No transaction was sent.",
      raw,
    };
  }

  // Contract revert
  if (lower.includes("revert") || lower.includes("execution reverted")) {
    return {
      kind: "REVERT",
      msg: "The payment was rejected by the contract (reverted). No transaction was sent.",
      raw,
    };
  }

  return {
    kind: "UNKNOWN",
    msg: raw ? String(raw) : "Base payment failed. Please try again.",
    raw,
  };
}
